// extracted by mini-css-extract-plugin
export default {"pg":"Layout_pg__7zyXs","main":"Layout_main__oFpTt"};